import { SensorResponse } from "@/api/v1/sensor-api"
import { ColumnDef } from "@tanstack/react-table"
import { Button } from "@/components/ui/button"
import { Link } from "@tanstack/react-router"
import { Badge } from "@/components/ui/badge"

export const columns: ColumnDef<SensorResponse>[] = [
    {
        accessorKey: "name",
        header: "Name",
        cell: ({ row }) => {
            const sensorSlug = row.original.slug || row.original.organisation_id.toString()
            return (
                <Link className="hover:underline" to={`/sensors/$sensorId`} params={{ sensorId: sensorSlug }}>
                    {row.getValue("name")}
                </Link>
            )
        }
    },
    {
        accessorKey: "status",
        header: "Status",
        cell: info => <Badge variant={'secondary'}>{info.getValue() as string}</Badge>
    },
    {
        accessorKey: "access_mode",
        header: "Access Mode",
        cell: info => <Badge variant={'outline'}>{info.getValue() as string}</Badge>
    },
    {
        accessorKey: "latitude",
        header: "Latitude",
        cell: info => info.getValue() ? (info.getValue() as number).toFixed(4) : "N/A",
    },
    {
        accessorKey: "longitude",
        header: "Longitude",
        cell: info => info.getValue() ? (info.getValue() as number).toFixed(4) : "N/A",
    },
    {
        accessorKey: "created_at",
        header: "Created At",
        cell: info => new Date(info.getValue() as string).toLocaleString(),
    },
    {
        id: "actions",
        header: "Actions",
        cell: ({ row }) => {
            const sensor = row.original
            const sensorSlug = sensor.slug || sensor.organisation_id.toString()
            return (
                <Button variant="outline" size="sm" asChild>
                    <Link to={`/sensors/$sensorId`} params={{ sensorId: sensorSlug }}>View Details</Link>
                </Button>
            )
        },
    },
]
